function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "gitlab-file-artifact_svg__a",
  d: "M0 1173.333h2000V0H0v1173.333z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 -359 814.333)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "gitlab-file-artifact_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gitlab-file-artifact_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#gitlab-file-artifact_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M851.199 554.108l-27.559 84.815-54.617 168.097c-2.81 8.648-15.046 8.648-17.856 0l-54.619-168.097H515.181l-54.62 168.097c-2.809 8.648-15.045 8.648-17.856 0l-54.617-168.097-27.557-84.815a18.775 18.775 0 016.82-20.992l238.513-173.29 238.515 173.29a18.777 18.777 0 016.82 20.992",
  fill: "#FC6D26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605.865 359.827l90.684 279.096H515.18l90.684-279.096z",
  fill: "#E24329"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605.865 359.827L515.18 638.922H388.089l217.776-279.095z",
  fill: "#FC6D26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.089 638.923l-27.56-84.815a18.773 18.773 0 016.822-20.99l238.514-173.29-217.776 279.095z",
  fill: "#FCA326"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.089 638.922H515.18L460.56 807.02c-2.81 8.649-15.046 8.649-17.855 0l-54.617-168.098z",
  fill: "#E24329"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605.865 359.827l90.684 279.095H823.64L605.865 359.827z",
  fill: "#FC6D26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M823.64 638.923l27.559-84.815a18.773 18.773 0 00-6.821-20.99l-238.514-173.29L823.64 638.923z",
  fill: "#FCA326"
}), /*#__PURE__*/React.createElement("path", {
  d: "M823.64 638.922H696.548l54.619 168.098c2.81 8.649 15.047 8.649 17.856 0l54.617-168.098z",
  fill: "#E24329"
})));

function SvgGitlabFileArtifact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 455
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "gitlab-file-artifact.ab089.svg";
export { SvgGitlabFileArtifact as ReactComponent };